export const IsMediaRecorderExist = typeof MediaRecorder !== 'undefined';
